import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import RecipeDetail from "./pages/RecipeDetail";
import MealPlanner from "./pages/MealPlanner";
import CreateBuddy from "./pages/CreateBuddy";
import Cart from "./pages/Cart";
import Pilot from "./pages/Pilot";
import ProductDetail from "./pages/ProductDetail";
import Admin from "./pages/Admin";
import Investors from "./pages/Investors";
import Library from "./pages/Library";
import FreeBuddy from "./pages/FreeBuddy";
import Shop from "./pages/Shop";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Refunds from "./pages/Refunds";
import BuddyShare from "./pages/BuddyShare";
import Journal from "./pages/Journal";
import JournalPost from "./pages/JournalPost";
import CreateYourPlateBuddy from "./pages/CreateYourPlateBuddy";
import EtsyRedirect from "./pages/EtsyRedirect";
import HappyPlateRedirect from "./pages/HappyPlateRedirect";
import RegeneratedRedirect from "./pages/RegeneratedRedirect";
import LoginPage from "./pages/LoginPage";
import EmailSignature from "./pages/EmailSignature";
import { CartProvider } from "./lib/cart";
import { AccessProvider } from "./lib/access";
import { AuthProvider } from "./lib/auth";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <AccessProvider>
          <CartProvider>
            <BrowserRouter>
              <Toaster position="top-center" richColors />
              <Routes>
                <Route path="/" element={<CreateYourPlateBuddy />} />
                <Route path="/home" element={<Home />} />
                <Route path="/create" element={<CreateBuddy />} />
                <Route path="/planner" element={<MealPlanner />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/recipes/:id" element={<RecipeDetail />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/pilot" element={<Pilot />} />
                <Route path="/products/:productId" element={<ProductDetail />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/investors" element={<Investors />} />
                <Route path="/library" element={<Library />} />
                <Route path="/free-buddy" element={<FreeBuddy />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/refunds" element={<Refunds />} />
                <Route path="/journal" element={<Journal />} />
                <Route path="/journal/:slug" element={<JournalPost />} />
                <Route path="/create-your-plate-buddy" element={<CreateYourPlateBuddy />} />
                <Route path="/buddies/:id/share" element={<BuddyShare />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                <Route path="/etsy" element={<EtsyRedirect />} />
                <Route path="/etsy-strategy" element={<EtsyRedirect />} />
                <Route path="/happy-plate" element={<HappyPlateRedirect />} />
                <Route path="/regenerated" element={<RegeneratedRedirect />} />
                <Route path="/buddies" element={<RegeneratedRedirect />} />
                <Route path="/email-signature" element={<EmailSignature />} />
                <Route path="/signature" element={<EmailSignature />} />
              </Routes>
            </BrowserRouter>
          </CartProvider>
        </AccessProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
